import React from 'react';
import { motion } from 'framer-motion';
export function PainPoint() {
  return <section className="py-20 bg-gray-50" data-id="element-209" data-mp="1wgysgksnd3ep">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-210" data-mp="1wi02clxxfjuu">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} data-id="element-211" data-mp="2b5ux07vhvyak">
          <span className="text-red-600 font-bold tracking-wider uppercase text-sm mb-4 block" data-id="element-212" data-mp="2g4emujd7lu87">
            Tired of agencies that don't deliver results?
          </span>

          <h2 className="text-4xl md:text-5xl font-extrabold text-gray-900 mb-8 tracking-tight" data-id="element-213" data-mp="2p6e4ndw1t2c7">
            We see it all the time...
          </h2>

          <div className="space-y-6 text-lg md:text-xl text-gray-600 leading-relaxed max-w-3xl mx-auto" data-id="element-214" data-mp="zs97umpmxwp1">
            <p data-id="element-215" data-mp="1qt343ls7jife">
              You're pouring money into ads, but the leads aren't converting.
              Your SEO agency sends you reports full of vanity metrics, but your
              phone isn't ringing.
            </p>
            <p data-id="element-216" data-mp="1ztj1qem9rvcc">
              You're frustrated by cookie-cutter strategies, lack of
              transparency, and account managers who don't understand your
              business.
            </p>
            <p className="font-medium text-gray-900" data-id="element-217" data-mp="29kdodk3fgwyb">
              It's time for a marketing partner that focuses on what actually
              matters:{' '}
              <span className="text-red-600" data-id="element-218" data-mp="2eki95mbdcduc">ROI and Conversions.</span>
            </p>
          </div>

          <div className="mt-10" data-id="element-219" data-mp="2njdekw6l9jwl">
            <a href="#services" className="inline-flex items-center text-red-600 font-semibold hover:text-red-700 transition-colors group" data-id="element-220" data-mp="2njn6wqf3w35g">
              See how we do things differently
              <svg className="ml-2 w-5 h-5 group-hover:translate-x-1 transition-transform" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-221" data-mp="t5ujru3y0fez">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M14 5l7 7m0 0l-7 7m7-7H3" data-id="element-222" data-mp="1rjhzdvvrx9eg" />
              </svg>
            </a>
          </div>
        </motion.div>
      </div>
    </section>;
}